<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ pageTitle }}</h1>
                        </div>
                    </div>

                    <!-- Options -->
                    <div class="col-12">
                        <div class="card-grid grid-col-2 row">
                            <div class="selectable-card"
                                 @click="selectInsuranceState(true)"
                                 :class="{'active': hasInsuranceStatus === true}">
                                <div class="card-body py-4">
                                    <div class="card-img mb-4">
                                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/thumbs-up.svg" alt="Thumbs up">
                                    </div>
                                    <h6><strong>Yes</strong></h6>
                                </div>
                            </div>
                            <div class="selectable-card"
                                 @click="selectInsuranceState(false)"
                                 :class="{'active': hasInsuranceStatus === false}">
                                <div class="card-body py-4">
                                    <div class="card-img mb-4">
                                        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/thumbs-down.svg" alt="Thumbs down">
                                    </div>
                                    <h6><strong>No</strong></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: previousStep}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <router-link :to="{ name: 'repairSelect'}" class="btn btn-lg continue-btn icon-right ml-auto">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "DeviceInsuranceStatus",

        mounted() {
            this.checkCanBeOnPage();
        },

        computed: {
            ...mapGetters(['hasInsuranceStatus','isBookingInStore', 'makeIsSamsung', 'modelVersionHasBeenSelected']),

            pageTitle() {
                if (this.isBookingInStore) {
                    return "Does the device have insurance?";
                }

                return "Does your device have insurance?";
            },

            previousStep() {
                if (this.makeIsSamsung) {
                    return "deviceFaultType";
                }
                return "deviceColour";
            }
        },

        methods: {
            ...mapActions(['checkBookingIsComplete', 'selectInsuranceState']),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.modelVersionHasBeenSelected) {
                        this.$router.push({name: 'deviceColour'});
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>